// https://www.w3schools.com/tags/ref_urlencode.ASP
// encode examples got from link above
export const encodeLinkSymbols = linkString => {
  const symbolsToReplace = {
    "#": "%23",
    "&": "%26",
    "/": "%2F",
    ":": "%3A",
    ";": "%3B",
    "=": "%3D",
    "@": "%40",
    "\\+": "%2B",
    "\\,": "%2C",
    "\\[": "%5B",
    "\\],": "%5D",
    "'": "%27",
  };

  for (const [key, value] of Object.entries(symbolsToReplace)) {
    const rgx = new RegExp(key, "gi");
    linkString = linkString.replace(rgx, value);
  }

  return linkString;
};

export const decodeLinkSymbols = linkString => {
  const symbolsToReplace = {
    "%23": "#",
    "%26": "&",
    "%2F": "/",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@",
    "%2B": "\\+",
    "%2C": "\\,",
    "%5B": "\\[",
    "%5D": "\\],",
    "%27": "'",
  };

  for (const [key, value] of Object.entries(symbolsToReplace)) {
    const rgx = new RegExp(key, "gi");
    linkString = linkString.replace(rgx, value);
  }

  return linkString;
};
